module.exports = __webpack_public_path__ + "static/exame-informatica-volt-logos-8e33df5b1f828ffc7b110f3333686944.png";